import ArrowOff from '../../../../public/icons/arrow_off.svg'
import ArrowOn from '../../../../public/icons/arrow_on.svg'
import BannerCouponIcon from '../../../../public/icons/coupon_icn.svg'
import DarkCautionIcon18 from '../../../../public/icons/dark_icn_caution_18.svg'
import GrayFillIcon14 from '../../../../public/icons/gray_fill_14.svg'
import BoldDownIcon16 from '../../../../public/icons/icn_arrow_right_bold_down_16.svg'
import BoldUpIcon16 from '../../../../public/icons/icn_arrow_right_bold_up_16.svg'
import AppleIcon from '../../../../public/icons/light_icn_24_apple.svg'
import FacebookIcon from '../../../../public/icons/light_icn_24_facebook.svg'
import NaverIcon from '../../../../public/icons/light_icn_24_naver.svg'
import DownArrowIcon from '../../../../public/icons/light_icn_arrow_16_down.svg'
import RightIcon from '../../../../public/icons/light_icn_arrow_16_right.svg'
import ArrowUpIcon from '../../../../public/icons/light_icn_arrow_16_up.svg'
import BackIcon from '../../../../public/icons/light_icn_arrow_24_left.svg'
import TicketPurchaseIcon from '../../../../public/icons/light_icn_arrow_24_outline.svg'
import DownIcon12 from '../../../../public/icons/light_icn_arrow_down_12.svg'
import LeftIcon from '../../../../public/icons/light_icn_arrow_left_12.svg'
import UpIcon12 from '../../../../public/icons/light_icn_arrow_up_12.svg'
import BulletIcon from '../../../../public/icons/light_icn_bullet_small_12.svg'
import CalendarIcon from '../../../../public/icons/light_icn_calendar_20.svg'
import LightCautionIcon18 from '../../../../public/icons/light_icn_caution_18.svg'
import CautionIcon from '../../../../public/icons/light_icn_caution_24_rectangle.svg'
import CautionIcon40 from '../../../../public/icons/light_icn_caution_40.svg'
import YellowCautionIcon18 from '../../../../public/icons/light_icn_caution_yellow_18.svg'
import CheckOffIcon from '../../../../public/icons/light_icn_check_off_24.svg'
import CloseIcon12 from '../../../../public/icons/light_icn_close_12.svg'
import CloseIcon24 from '../../../../public/icons/light_icn_close_24.svg'
import CircleCloseIcon from '../../../../public/icons/light_icn_close_circle_24.svg'
import CopyIcon from '../../../../public/icons/light_icn_copy_18.svg'
import CopyFillIcon from '../../../../public/icons/light_icn_copy_18_fill.svg'
import InputEditIcon from '../../../../public/icons/light_icn_editinfo_32.svg'
import ExpiredIcon40 from '../../../../public/icons/light_icn_expired_40.svg'
import GpsIcon from '../../../../public/icons/light_icn_gps_24.svg'
import GuideIcon from '../../../../public/icons/light_icn_guid_18.svg'
import RefundHelpIcon from '../../../../public/icons/light_icn_help_16.svg'
import HelpIcon from '../../../../public/icons/light_icn_help_18.svg'
import KakaoIcon from '../../../../public/icons/light_icn_kakao_18.svg'
import LocationIcon from '../../../../public/icons/light_icn_location_24.svg'
import ParkinglotLocationIcon from '../../../../public/icons/light_icn_location_32.svg'
import ZoomOutIcon from '../../../../public/icons/light_icn_minus_24.svg'
import ModuLogo from '../../../../public/icons/light_icn_modu_18.svg'
import NaviIconStroke from '../../../../public/icons/light_icn_navi_18.svg'
import NaviIcon from '../../../../public/icons/light_icn_navi_24.svg'
import AirportLocationIcon from '../../../../public/icons/light_icn_pin.svg'
import PinShadowIcon from '../../../../public/icons/light_icn_pin_shadow_12.svg'
import ZoomInIcon from '../../../../public/icons/light_icn_plus_24.svg'
import PositionIcon from '../../../../public/icons/light_icn_position_32.svg'
import RadioClickedIcon from '../../../../public/icons/light_icn_radio_clicked_24.svg'
import RadioUnclickedIcon from '../../../../public/icons/light_icn_radio_unclicked_24.svg'
import RefundListIcon from '../../../../public/icons/light_icn_refund_list_18.svg'
import RefundPlusIcon from '../../../../public/icons/light_icn_refund_plus_24.svg'
import RoadViewIcon from '../../../../public/icons/light_icn_roadview_18.svg'
import SearchIcon from '../../../../public/icons/light_icn_search_bold_24.svg'
import SharePIcon from '../../../../public/icons/light_icn_share_18.svg'
import ShareIcon from '../../../../public/icons/light_icn_share_24.svg'
import ThumbsUp from '../../../../public/icons/light_icn_thumbsup_18.svg'
import AirportIcon from '../../../../public/icons/light_img_airport.svg'
import DiscountIcon from '../../../../public/icons/light_img_discount_24.svg'
import NormalPinIcon from '../../../../public/icons/light_img_pin_notpartner_56.svg'
import PartnerPinIcon from '../../../../public/icons/light_img_pin_partner_56.svg'
import SharePinIcon from '../../../../public/icons/light_img_pin_share_56.svg'
import MainFillIcon14 from '../../../../public/icons/main_fill_14.svg'
//Sample

const Icons = {
  //Sample
  CheckOffIcon,
  AppleIcon,
  FacebookIcon,
  NaverIcon,

  //---------------------------
  //주차핀 설명
  CautionIcon,

  //지도 핀
  PartnerPinIcon,
  SharePinIcon,
  NormalPinIcon,
  AirportIcon,

  //MapController
  GpsIcon,
  ZoomInIcon,
  ZoomOutIcon,
  LocationIcon,
  PinShadowIcon,
  PositionIcon,
  ParkinglotLocationIcon,

  //main 검색바
  ModuLogo,
  HelpIcon,
  SearchIcon,

  //모아이 추천 아이콘
  ThumbsUp,

  //주차권 상세 헤더
  BackIcon,
  ShareIcon,

  ArrowOn,
  ArrowOff,

  //탑배너
  //입차예정시간안내(구매) 더보기 >
  //주차권 상세 주차권 상단 > 아이콘
  LeftIcon,

  //주차권 상세 구매하기 옆 아이콘
  TicketPurchaseIcon,

  //bullet 아이콘
  BulletIcon,

  //내 주차권 상세 내비 아이콘
  NaviIcon,

  //내 주차권, 주차권 상세 더보기 > 아이콘
  RightIcon,

  //카카오톡 공유하기 아이콘
  KakaoIcon,

  //복사 아이콘
  CopyFillIcon,
  CopyIcon,

  //주차권 상세 요약정보 공유,로드뷰,내비 아이콘
  SharePIcon,
  RoadViewIcon,
  NaviIconStroke,

  //전체보기 아래 버튼
  DownArrowIcon,

  BannerCouponIcon,

  //주차권, 주차장 상세 배너 아이콘
  DiscountIcon,

  //환불
  RefundHelpIcon,
  RefundPlusIcon,
  RefundListIcon,
  CloseIcon24,

  //배너 x
  CloseIcon12,
  DarkCautionIcon18,

  UpIcon12,
  DownIcon12,
  BoldDownIcon16,
  BoldUpIcon16,

  LightCautionIcon18,
  YellowCautionIcon18,
  CautionIcon40,
  ExpiredIcon40,

  //하단 배너x
  CircleCloseIcon,

  // 공항 아이콘
  CalendarIcon,
  AirportLocationIcon,

  // 라디오 버튼용 아이콘
  RadioClickedIcon,
  RadioUnclickedIcon,

  //결제하기 dropdown 아이콘
  ArrowUpIcon,
  InputEditIcon,

  GuideIcon,
  MainFillIcon14,
  GrayFillIcon14
}

export default Icons
